import { createFileRoute } from '@tanstack/react-router';
import { EcranSysteme } from '../admin/systeme/EcranSysteme';

export const Route = createFileRoute('/admin/systeme')({
  component: EcranSysteme,
});
